import { Box, Button, Checkbox, Grid, Typography } from "@mui/material";
import { createRef, useCallback, useContext, useEffect, useState } from "react";
import { FieldsContext } from "./WebFormWorkspace";
import { TextBoxLatest } from "../common/TextBoxLatest/TextBoxLatest";
import { iWebFormField } from "./schema";
import CustomSelect from "../common/customSelect";
import CustomFormLabel from "../common/form-label/CustomFormLabel ";
import { triggerAppAlert } from "../../redux/actions/SelfServicePortal/ContactAid/ContactAid";
import { useDispatch } from "react-redux";

const WebFormProperties = () =>{
    const dispatch = useDispatch();
    // const {setEditIndex,blocks,editIndex,setBlocks,editFieldVal} = useContext(FieldsContext)
    const {blocks,setBlocks,setEditFieldIndex,editFieldIndex,setEditFieldVal,editFieldVal} = useContext(FieldsContext)
//     console.log('WebFormProperties',editFieldVal)
    const labelRef:any = createRef();
    const descRef:any = createRef();
    const optionsRef:any = createRef();
    const checkBoxRef:any = createRef();
    const placeHolderRef:any = createRef();


    const [conditionalField,setConditionalField] = useState<any>(null)


    const submitHandler = ()=>{
        if(conditionalField && !conditionalField?.value?.length){
            dispatch(triggerAppAlert("Please select a value for the conditional field before submitting.", "error"));
            return;
        }
//         console.log('WebFormProperties_Submit',editFieldIndex,blocks)
        const temp = {val:[...blocks.map((i:iWebFormField,index:number)=>{
            if(index === editFieldIndex){
                i.isMandatory = checkBoxRef?.current?.checked || false;
                i.fieldLabel = labelRef?.current?.value;
                // i.id = Math.random() * 10000000000000000000;
                i.fieldPlaceholder = placeHolderRef?.current?.value;
                i.fieldDescription = descRef?.current?.value;
                i.fieldOptions = optionsRef?.current?.value;
                i.visibility = conditionalField ? {
                    field: {id : conditionalField.field.id, fieldLabel: conditionalField.field.label},
                    value: conditionalField.value.map((i:any)=>i.value)
                } : null;
            }
            return i;
        })]}
        setBlocks(JSON.parse(JSON.stringify(temp)).val)
        setTimeout(()=>{
            cancelHandler()
        },100)
    }
    const cancelHandler = ()=>{
        setEditFieldIndex(null)
    }
    useEffect(()=>{
        if(labelRef?.current){
            labelRef.current.value  = editFieldVal?.fieldLabel || "";
        }
        if(descRef?.current){
            descRef.current.value = editFieldVal?.fieldDescription || "";
        }
        if(placeHolderRef?.current){
            placeHolderRef.current.value = editFieldVal?.fieldPlaceholder || "";
        }
        if(optionsRef?.current){
            optionsRef.current.value = editFieldVal?.fieldOptions || "";
        }
        if(checkBoxRef?.current){
            checkBoxRef.current.checked = true;
        }
        if(editFieldVal.visibility){
            const field = blocks.find((i:any)=>i.id == editFieldVal.visibility.field.id)
            
            const tempObj = {
                label: field.fieldLabel,
                value: field.fieldId,
                id: field.fieldId,
                optionsList : field.fieldOptions?.split("|").map((j:string)=>{return {label:j,value:j}}),
            };
            setConditionalField({
                field: tempObj,
                value: editFieldVal.visibility.value.map((i:string)=>({label:i,value:i})),
            });
        }
    },[editFieldVal])




    return (
        <>
            
            <Grid item md={3} xs={12}>
                <Box className="aside">
                    <Typography>Properties</Typography>
                    <hr />
                    <Box className="form-properties">
                    <TextBoxLatest
                        multiline={false}
                        title="Field Title"
                        placeholder="Please Enter"
                        ref={labelRef}
                        isMandotary={false}
                    />
                    <TextBoxLatest
                            multiline={true}
                            title= {editFieldVal?.fieldType === "Heading" ? "Enter Description" : "Enter Helper Text"}
                            placeholder= {editFieldVal?.fieldType === "Heading" ? "Enter Description" : "Enter Helper Text"}
                            ref={descRef}
                            isMandotary={false}
                    />
                    {(editFieldVal?.fieldType === "DropDown" || editFieldVal?.fieldType === "CheckBox") &&
                        <TextBoxLatest
                            multiline={true}
                            title="Field Options"
                            placeholder="Please Enter"
                            ref={optionsRef}
                            isMandotary={false}
                        />
                    }
                    {(editFieldVal?.fieldType !== "Heading" && editFieldVal?.fieldType !== "CheckBox" && editFieldVal?.fieldType !== "DropDown") &&
                        <>
                            <TextBoxLatest
                                multiline={false}
                                title="Field Placeholder"
                                placeholder="Please Enter"
                                ref={placeHolderRef}
                                isMandotary={false}
                            />
                        </>
                    }
                    {(editFieldVal?.fieldType !== "Heading") &&
                        <>
                            <Typography className={`radio-label`}>
                                <Checkbox 
                                    defaultChecked={editFieldVal?.isMandatory || false}
                                    inputRef={checkBoxRef} 
                                />
                                <span>Mandatory Field</span>
                            </Typography> &nbsp;&nbsp;
                        </>
                    }
                    </Box>
                    {/*
                        conditional rendering based on other field values, for an example, if the designation dropdown value is student ask for student id, and if it's employee ask for employee id, and if it's other ask for other id, and if it's none don't ask for any id
                    */}
                    {blocks.length - 1 !== 0 &&
                    <Box className="conditional-rendering">
                        <hr/>
                        <Box className="row m-0 justify-content-between align-items-center">
                            <Typography className="conditional-rendering-label">Conditional Rendering</Typography>
                            {conditionalField && 
                            <Button variant="text" sx={{p:0}} onClick={() => setConditionalField(null)}>
                                Clear
                            </Button>
                            }
                        </Box>
                        <hr/>
                    <Box className="form-condtional-rendering">

                        <Box className="conditional-rendering-field">
                            <CustomFormLabel
                                labelName={"Field"}
                                isMandotary={false}
                            />
                                <CustomSelect
                                    isOpen={false}
                                    placeholder="Select a field"
                                    width={"100%"}
                                    name="field"
                                    isColor={false}
                                    isDisabled={false}
                                    isError={false}
                                    defaultValue={conditionalField?.field || null}
                                    options={blocks.filter((i:iWebFormField)=>(i.fieldType === "CheckBox" || i.fieldType === "DropDown") && i.id !== editFieldVal?.id).map((i:iWebFormField)=>{
                                        return {
                                            label: i.fieldLabel,
                                            value: i.id,
                                            id: i.id,
                                            optionsList: i.fieldOptions?.split("|").map((j:string)=>{return {label:j,value:j}})
                                        }
                                    })}
                                    handleChange={(e: any) => {
                                        setConditionalField((old: any)=>{
                                            return {
                                                ...(old||{}),
                                                field: e,
                                                value:null
                                        }
                                        })
                                        console.log("selected field", e);   
                                    }}
                                    isMulti={false}
                                />
                            </Box>
                            {conditionalField?.field?.optionsList &&
                            <Box className="conditional-rendering-field">
                                <CustomFormLabel
                                    labelName={"Value"}
                                    isMandotary={true}
                                />
                                <CustomSelect
                                    isOpen={false}
                                    placeholder="Select a value"
                                    width={"100%"}
                                    name="value"
                                    isColor={false}
                                    isDisabled={false}
                                    isError={false}
                                    defaultValue={conditionalField?.value || null}
                                    options={conditionalField.field?.optionsList || []}
                                    handleChange={(e: any) => {
                                        setConditionalField((old: any)=>{
                                            return {
                                                ...old,
                                                value: e
                                        }
                                        })
                                        console.log("selected field", e);   
                                    }}
                                    isMulti={true}
                                />
                            </Box>
                            }
                    </Box>
                    </Box> 
                    }

                    <Box className="pt-1 text-center">
                    <Button size="small" variant="outlined" onClick={cancelHandler}>
                        Cancel
                    </Button> &nbsp; &nbsp;
                    <Button size="small" variant="contained" onClick={submitHandler}>
                        Submit
                    </Button>

                    <br/><br/><br/><br/><br/>
                    <br/><br/><br/><br/><br/>
                    </Box>
                </Box>
            </Grid>
        </>
    )
}
export default WebFormProperties;